import { HomeUI } from './ui';

export const HomePage = () => {
  return <HomeUI />;
};

export default HomePage;
